import { render, staticRenderFns } from "./result-slideshow.vue?vue&type=template&id=ef18d988&"
import script from "./result-slideshow.vue?vue&type=script&lang=ts&"
export * from "./result-slideshow.vue?vue&type=script&lang=ts&"
import style0 from "./result-slideshow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports